module.exports = __webpack_public_path__ + "img/logoirsmarket1.cbc4dcce.png";